export const NavigationDirection = Object.freeze({
  none: Symbol('none'),
  forward: Symbol('forward'),
  backward: Symbol('backward'),
});
